import Cookies from 'js-cookie';
import { FormEvent, SyntheticEvent, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {Box, Button, Container, Rating, Typography} from '@mui/material';
import {TextareaAutosize} from '@mui/base/TextareaAutosize';
import {urls} from '../../services/endPoint';
import {api} from '../../services/http';
import { useAppSelector } from '../../services/redux/store';
import { IOrder } from '../../services/types';
import Success from './success';
import {toast} from 'react-toastify';

export default function Feedback() {
  const [rate, setRate] = useState(0);
  const [comment, setComment] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [order, setOrder] = useState<IOrder>();
  const [tab, setTab] = useState('good');
  const [factors, setFactors] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const tabTitles = {
    good: 'نقاط قوت',
    bad: 'نقاط ضعف',
  }

  const handleRate = (e: SyntheticEvent, newRate: number | null) => {
    if (newRate) setRate(newRate);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!comment) {
      toast('نظر خود را وارد کنید');
      return;
    }
    if (rate === 0) {
      toast('ابتدا امتیاز بدهید')
      return;
    }
    const reqBody = {
      orderId: order.id,
      rate,
      comment,
    };

    const res = await api(urls.feedback, { method: 'post', body: reqBody}, true);
    if (res.code === 200) {
      setIsSubmitted(true);
    }
  };

  const fetchFactors = async () => {
    const res = await api(urls.feedbackFactors, { method: 'GET'})
    setFactors(res.data)
  };

  const fetchData = async () => {
    const res = await api(urls.orderSingle + '/' + params.id, {}, true)
    if (!res.data){
      navigate('/')
    } else if (res.data?.feedback){
      toast('نظرسنجی این سفارش قبلا ثبت شده است.', { type: 'error', onClose: () => navigate('/') })
    } else {
      setOrder(res.data)
    }
  };

  useEffect(() => {
    if (Cookies.get('worker-token') == undefined){
      toast('لطفا ابتدا وارد شوید', { type: 'error' })
      navigate(`/login?from=/feedback/${params.id}`)
    } else {
      fetchFactors();
      fetchData()
    }
  }, []);

  return (
    <Box component="main" minHeight="100vh">
      <Container
        sx={{
          flex: 1,
          display: 'flex',
          py: 2,
          flexDirection: 'column',
          gap: 4,
          minHeight: '100vh',
        }}
      >
        {!isSubmitted ? (
          <>
            <Typography variant="body2" lineHeight="26px" component="p">
              لطفا جهت نظارت و بهبود عملکرد، تجربه خود را با ما به اشتراک بگذارید.
            </Typography>
            <Box
              onSubmit={handleSubmit}
              component="form"
              display="flex"
              flexDirection="column"
              gap={4}
            >
              <Rating
                name="rating"
                size="large"
                value={rate}
                // dir={'ltr'}
                onChange={handleRate}
                sx={{
                  marginInline: 'auto',
                  '& .muirtl-1vooibu-MuiSvgIcon-root': {width: 42, height: 42},
                  '& .MuiRating-iconFilled': {color: 'var(--mid-pink)'},
                }}
              />

              <div className='feedbackFactors'>
                <div className='feedbackFactorsCol'>
                  <span className='feedbackFactorsCell head'>نقاط مثبت</span>
                  {factors?.filter(e => e.isPositive).map(e => <span className='feedbackFactorsCell positive'>{e.title}</span>)}
                </div>
                <div className='feedbackFactorsCol'>
                  <span className='feedbackFactorsCell head'>نقاط منفی</span>
                  {factors?.filter(e => !e.isPositive).map(e => <span className='feedbackFactorsCell negative'>{e.title}</span>)}
                </div>
              </div>

              <TextareaAutosize
                className="comment-textarea"
                minRows={5}
                maxRows={6}
                name="comment"
                placeholder="نظر خود را بنویسید ..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />

              <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{backgroundColor: 'var(--mid-pink)'}}
              >
                ثبت
              </Button>
            </Box>
          </>
        ) : (
          <Success />
        )}
      </Container>
    </Box>
  );
}
